module.exports = __webpack_public_path__ + "static/media/icita2007.f6d591f9.png";